'use client'
import { useTranslate } from '@repo/shared/hooks'
import { useRouter } from '@repo/shared/i18n/navigation'
import { Button, Card, Icon, Row, Typography } from '@repo/ui/components'
import { useState } from 'react'
import { MobileKycForm } from './mobile-kyc.form'
import { MobileKycOtp } from './mobile-kyc.otp'

export const MobileKycContainer = () => {
  const [loginStep, setLoginStep] = useState<'otp' | 'login'>('login')
  const [mobile, setMobile] = useState<string>('')
  const [otp, setOtp] = useState<number>(0)
  const { t } = useTranslate()
  const { back } = useRouter()

  const handleFormSuccess = (mobileValue: string, otpValue: number) => {
    setMobile(mobileValue)
    setOtp(otpValue)
    setLoginStep('otp')
  }

  return (
    <div className='px-md'>
      {loginStep === 'otp' && (
        <MobileKycOtp
          mobile={mobile}
          otp={otp}
          handleBack={() => setLoginStep('login')}
        />
      )}
      {loginStep === 'login' && (
        <Card className='p-xl rounded-sm'>
          <Button
            startIcon={<Icon name='ArrowRightLine' />}
            variant='transparent'
            size='xs'
            onClick={back}
            className='gap-2xs'
          >
            {t('common_back')}
          </Button>
          <Typography size='2xl' weight='bold'>
            {t('common_register_mobile')}
          </Typography>
          <Row>
            <MobileKycForm onSuccess={handleFormSuccess} />
          </Row>
        </Card>
      )}
    </div>
  )
}
